import { TwitterShareButton } from 'components/SocialShareButtons'

import css from './Blockquote.module.css'

export default function Blockquote({ children }) {
    let textContent = null
    const [firstChild] = children
    if (firstChild) {
        const [text] = firstChild.props.children
        textContent = text
    }
    return (
        <blockquote className={css.blockquote}>
            {textContent && <TwitterShareButton title={textContent} />}
            {children}
        </blockquote>
    )
}
